import { IS_MAINNET } from '@shared/utils/constant'
import { Wallet } from '@injectivelabs/wallet-base'
import { EthereumChainId } from '@injectivelabs/ts-types'
import { updateEvmNetwork } from '@injectivelabs/wallet-evm'

export const switchToActiveMetamaskNetwork = async () => {
  const chainId = IS_MAINNET ? EthereumChainId.Mainnet : EthereumChainId.Sepolia

  await updateEvmNetwork(Wallet.Metamask, chainId).catch((err: Error) => {
    throw err
  })
}
